import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('obbVenditaAnnuali');
export const actions = helper.createActions('obbVenditaAnnuali', actionTypes);